import { DOCTYPES } from '@/constants/doctypes.ts'
import { PERMISSIONS } from '@/constants/permissions.ts'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeNewsletterArticleCreate,
  detail: routeNewsletterArticleDetail,
  home: routeNewsletterArticlesHome,
  root: routeNewsletterArticlesRoot,
} = createDoctypeRoutes({
  createName: 'new-newsletter-article',
  createPath: 'new-newsletter-article',
  detailName: 'newsletter-article-detail',
  doctype: DOCTYPES.NEWSLETTER,
  extraListDoctypes: { [DOCTYPES.REPORT]: [PERMISSIONS.READ] },
  homeName: 'newsletter-articles',
  path: 'newsletter-articles',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/newsletterArticles/AddNewsletterArticle.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/newsletterArticles/ViewNewsletterArticle.vue'),
    list: async () => await import('@/components/viewsExternal/newsletter/ViewNewsletter.vue'),
  },
})

export {
  routeNewsletterArticleCreate,
  routeNewsletterArticleDetail,
  routeNewsletterArticlesHome,
  routeNewsletterArticlesRoot,
}
